<template>

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar title="Saldos" exibeVoltar="true" historyback="true" /> 
        </div>
		<div class="app-centro-sem-rodape">
            <br/>
            <table style="width: 96%;" border="1" class="saldo table" align="center">
                
                <tr>
                    <th colspan="4" align="center">Fluxo de Caixa<br/>{{ new Date() | moment("DD/MM/YYYY, hh:mm") }}</th>
                    </tr>

                <tr>
                    <th width="24%" align="center"><b>Conta</b></th>
                    <th width="24%" align="center"><b>Saldo Atual</b></th>
                    <th width="24%" align="center"><b>Lcts. Futuros</b></th>
                    <th width="24%" align="center"><b>Saldo</b></th>
                </tr>
                

                <tbody  v-for="item in fluxo.FLUXO_CX" v-bind:key="item.DESC_CONTA">
                    <tr>
                        <td>{{ item.DESC_CONTA }} ({{ item.COD_CONTA }})</td>
                        <td><span-valor :valor="item.SALDO_DEVEDOR_ATUAL"/></td>
                        <td><span-valor :valor="item.SALDO_DEVEDOR_FUTURO"/></td>
                        <td><span-valor :valor="item.SALDO_DEVEDOR_GERAL"/></td>
                    </tr>
                </tbody>
                <tr>
                    <td ><b>Total:</b></td>
                        <td><span-valor :valor="totalAtual"/></td>
                        <td><span-valor :valor="totalFuturo"/></td>
                        <td><span-valor :valor="totalGeral"/></td>
                </tr>
            </table>      
        </div>

	</div>


    
</template>

<script>

import request from '@/services/services.js';
import TopBar from '@/components/layout/TopBar.vue';
import SpanValor from '@/components/shared/SpanValor.vue';

export default {
    name: 'Saldos',

    components : {
        TopBar,
        SpanValor
    },

    data() {
        return{
            fluxo : {}
        };
    },

    mounted: function () {

        request(this, 'GET',
            'Mobile_Get_Fluxo_Caixa')
        .then(res => {
            if(res){
                this.fluxo = res;
            }
        });

    },
    
    computed : {
        totalAtual: function() {
            if((this.fluxo.FLUXO_CX)&&(this.fluxo.FLUXO_CX.length)){
                return this.fluxo.FLUXO_CX.reduce((sum, item) => sum + parseFloat(item.SALDO_DEVEDOR_ATUAL), 0);
            } else {
                return 0;
            }
        },
        totalFuturo: function() {
            if((this.fluxo.FLUXO_CX)&&(this.fluxo.FLUXO_CX.length)){
                return this.fluxo.FLUXO_CX.reduce((sum, item) => sum + parseFloat(item.SALDO_DEVEDOR_FUTURO), 0);
            } else {
                return 0;
            }
        },
        totalGeral: function() {
            if((this.fluxo.FLUXO_CX)&&(this.fluxo.FLUXO_CX.length)){
                return this.fluxo.FLUXO_CX.reduce((sum, item) => sum + parseFloat(item.SALDO_DEVEDOR_GERAL), 0);
            } else {
                return 0;
            }
        }
    }


}
</script>

<style scoped>
  .saldo{
      font-size: 14px;

  }

    tr{
       height: 50px;

    }

  

  .table{
        border-collapse: collapse;
        width: calc(100% - 8px);

        border: 1px solid var(--dark-color);   

    }

    td{
        --border-collapse: collapse;
        border: 1px solid var(--dark-color);

    }

    th{
        

        border: 1px solid var(--dark-color);
        background-color: var(--primary-color);
        color: white;

    }
</style>